export default __webpack_public_path__ + "static/media/arrow-back.c865f502.svg";